<template>
  <figure class="ListItem">
    <SkeletItem
      v-if="isLoading"
      class="ListItem__image-skelet"
      :height="LIST_ITEM_HEIGHT"
    />
    <img
      :alt="props.label"
      :src="props.src"
      :height="`${LIST_ITEM_HEIGHT}px`"
      loading="lazy"
      @load="onLoad"
      class="ListItem__image"
      :class="{ 'ListItem__image--is-hidden': isLoading }"
    />
    <figcaption class="ListItem__caption">{{ props.label }}</figcaption>
  </figure>
</template>

<script setup>
  import { ref } from 'vue';
  import { Props } from './props';
  import { LIST_ITEM_HEIGHT } from '../../config/config';
  //-----------------------------
  import { SkeletItem } from '@/Groups/Slider/private/imports/externalTemplates';
  //-----------------------------
  const props = defineProps(Props());
  //-----------------------------
  const isLoading = ref(true);
  //-----------------------------
  const onLoad = () => {
    console.log('IMG LOADED');
    isLoading.value = false;
  };
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>